import { useEffect, useState } from "react";
import { SectionCard } from "../../components/SectionCard";
import { Button } from "../../components/ui/button";
import { api } from "../../api";
import { navigate } from "../../lib/router";
import type { BlogPost } from "../../types";

export default function BlogAdminPage() {
  const [posts, setPosts] = useState<BlogPost[]>([]);
  const load = async () => {
    const res = await api.listBlogPosts();
    if (res.ok) setPosts(res.data);
  };
  useEffect(() => {
    load();
  }, []);
  return (
    <div className="max-w-screen-md mx-auto p-4 flex flex-col gap-4">
      <SectionCard
        header={<h2 className="text-xl font-semibold">Posts do Blog</h2>}
        action={<Button onClick={() => navigate("/app/blog/new")}>Novo</Button>}
      >
        <div className="flex flex-col gap-4">
          {posts.map(p => (
            <div key={p.id} className="flex items-center justify-between">
              <div>
                <div className="font-medium">{p.title}</div>
                {p.subtitle && (
                  <div className="text-sm text-neutral-600">{p.subtitle}</div>
                )}
              </div>
              <Button
                variant="outline"
                size="sm"
                onClick={() => navigate(`/app/blog/${p.slug}/edit`)}
              >
                Editar
              </Button>
            </div>
          ))}
        </div>
      </SectionCard>
    </div>
  );
}
